import * as React from "react";

function SvgReordersFilled(props) {
  return <svg viewBox="0 0 38 40" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M29.417.167l-6.25 6.25 6.25 6.25V8.5h4.166v27.083H25.25v4.167h8.333c2.278 0 4.167-1.89 4.167-4.167V8.5c0-2.277-1.89-4.167-4.167-4.167h-4.166V.167zM.25 4.333V8.5h20.833V4.333H.25zm0 8.334v4.166h20.833v-4.166H.25zM.25 21v6.25h20.833V21H.25zm0 10.417v8.333h20.833v-8.333H.25z" /></svg>;
}

export default SvgReordersFilled;